<template>
  <div class="navigation_layout__container">
    <!-- header スロット未指定時は従来どおり NavigationBar を表示（後方互換） -->
    <slot name="header">
      <NavigationBar
        v-bind:title="navigationTitle"
        :navigation-bar-style="navigationBarStyle"
      />
    </slot>
    <div
      class="navigation_layout__contents_wrapper"
      :style="navigationContentStyle"
    >
      <slot name="contents"></slot>
    </div>
  </div>
</template>

<script>
import NavigationBar from '@/components/NavigationBar.vue'
export default {
  name: 'NavigationLayout',
  components: {
    NavigationBar,
  },
  props: {
    navigationTitle: String,
    navigationBarStyle: Object,
    navigationContentStyle: Object,
  },
}
</script>

<style scoped>
.navigation_layout__container {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.navigation_layout__contents_wrapper {
  min-height: 100vh;
  height: 100%;
  margin: 0;
  padding-top: 44px;
  overflow-x: hidden;
}
</style>
